
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import countryConf from "@/config/country";
const common_app = namespace("common_app");
const user = namespace("user");
const store = namespace("store");
@Component({})
export default class SwitchLang extends Vue {
  @common_app.State lang;
  @common_app.State country;
  @common_app.Mutation setLang;
  @common_app.Mutation setIsViewAlive;
  @user.Action queryUserMenus;
  @user.Action setCurrentStore;
  @store.State storeData;
  options: any = [];
  langValue: string = "";
  created() {
    const countryOptions = countryConf[this.country];
    this.options = Object.keys(countryOptions.useLang).map(key => {
      return {
        label: countryOptions.useLang[key].label,
        value: key
      };
    });
    this.langValue = this.lang;
    this.queryUserMenus({
      menuParent: "pc_root",
      resourceClass: "1"
    });
  }
  async handleLangChange(val) {
    this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.5)"
    });
    this.setLang(val);
    if (this.$route.name !== "login") {
      await this.queryUserMenus({
        menuParent: "pc_root",
        resourceClass: "1"
      });
      await this.setCurrentStore({
        orgCode: this.storeData.orgCode
      });
    }
    window.location.reload();
  }
}
